import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCancelEventRequest = {};
var _bulkCancelEventResponse = { results: '_bulkEventResult' };
var _bulkCreateEventRequest = { events: '_maskedEvent' };
var _bulkCreateEventResponse = { results: '_bulkEventResult' };
var _bulkEventResult = { item: '_event' };
var _bulkUpdateEventRequest = {
    events: '_bulkUpdateEventRequestMaskedEvent',
};
var _bulkUpdateEventRequestMaskedEvent = {
    fieldmask: 'google.protobuf.FieldMask',
    event: '_event',
};
var _bulkUpdateEventResponse = { results: '_bulkEventResult' };
var _cancelEventRequest = {};
var _cancelEventResponse = { event: '_event' };
var _createEventRequest = {
    fieldmask: 'google.protobuf.FieldMask',
    event: '_event',
};
var _createEventResponse = { event: '_event' };
var _event = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    start: '_zonedDate',
    end: '_zonedDate',
    adjustedStart: '_zonedDate',
    adjustedEnd: '_zonedDate',
    recurrenceRule: '_recurrenceRule',
};
var _getEventRequest = {};
var _getEventResponse = { event: '_event' };
var _listEventsByContactIdRequest = {};
var _listEventsByContactIdResponse = { events: '_event' };
var _listEventsByMemberIdRequest = {};
var _listEventsByMemberIdResponse = { events: '_event' };
var _listEventsRequest = {};
var _listEventsResponse = { events: '_event' };
var _maskedEvent = {
    fieldmask: 'google.protobuf.FieldMask',
    event: '_event',
};
var _queryEventsRequest = {};
var _queryEventsResponse = { events: '_event' };
var _recurrenceRule = { until: '_zonedDate', adjustedUntil: '_zonedDate' };
var _restoreEventDefaultsRequest = {};
var _restoreEventDefaultsResponse = { event: '_event' };
var _splitRecurringEventRequest = {};
var _splitRecurringEventResponse = {
    updatedRecurringEventEndingBeforeSplit: '_event',
    newRecurringEventStartingFromSplit: '_event',
};
var _updateEventRequest = {
    fieldmask: 'google.protobuf.FieldMask',
    event: '_event',
};
var _updateEventResponse = { event: '_event' };
var _zonedDate = { utcDate: 'google.protobuf.Timestamp' };
function resolveWixCalendarParticipanteventsV3ParticipantEventsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/participant-events-3',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/calendar/v3/events/memberId',
                destPath: '/v3/events/memberId',
            },
            {
                srcPath: '/_api/calendar/v3/events/contactId',
                destPath: '/v3/events/contactId',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/calendar/v3/events/contactId',
                destPath: '/v3/events/contactId',
            },
            {
                srcPath: '/calendar/v3/events/memberId',
                destPath: '/v3/events/memberId',
            },
        ],
        _: [
            {
                srcPath: '/_api/calendar/v3/events/memberId',
                destPath: '/v3/events/memberId',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/calendar/v3/events/memberId',
                destPath: '/v3/events/memberId',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixCalendarEventsV3EventsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/events-3',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/calendar/v3/events',
                destPath: '/v3/events',
            },
            {
                srcPath: '/_api/calendar/v3/bulk/events',
                destPath: '/v3/bulk/events',
            },
            {
                srcPath: '/_api/calendar/v3/ro/events',
                destPath: '/v3/events',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/calendar/v3/events',
                destPath: '/v3/events',
            },
            {
                srcPath: '/calendar/v3/bulk/events',
                destPath: '/v3/bulk/events',
            },
            {
                srcPath: '/calendar/v3/ro/events',
                destPath: '/v3/events',
            },
        ],
        _: [
            {
                srcPath: '/_api/calendar/v3/events',
                destPath: '/v3/events',
            },
            {
                srcPath: '/_api/calendar/v3/bulk/events',
                destPath: '/v3/bulk/events',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/calendar/v3/events',
                destPath: '/v3/events',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves an event by ID. */
export function getEvent(payload) {
    var _a = serializer(_getEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEventResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __getEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'GET',
            methodFqn: 'wix.calendar.events.v3.EventsService.GetEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events/{eventId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEvent.fromReq = fromReq;
    __getEvent.__isAmbassador = true;
    return __getEvent;
}
/** Retrieves a list of events by their IDs. */
export function listEvents(payload) {
    var _a = serializer(_listEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listEventsResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __listEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'GET',
            methodFqn: 'wix.calendar.events.v3.EventsService.ListEvents',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listEvents.fromReq = fromReq;
    __listEvents.__isAmbassador = true;
    return __listEvents;
}
/**
 * Query events given the provided time range, filters and paging.
 *
 * Sort: by default events are sorted by their start date in ascending order. Events can also be sorted by their end date in descending order.
 * > __Note__ Querying by IDs is not supported, please use the GetEvent or ListEvents APIs instead.
 */
export function queryEvents(payload) {
    var _a = serializer(_queryEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryEventsResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __queryEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.QueryEvents',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryEvents.fromReq = fromReq;
    __queryEvents.__isAmbassador = true;
    return __queryEvents;
}
/** Creates an event. */
export function createEvent(payload) {
    var _a = serializer(_createEventRequest, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createEventResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __createEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.CreateEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createEvent.fromReq = fromReq;
    __createEvent.__isAmbassador = true;
    return __createEvent;
}
/** Creates multiple events in bulk. */
export function bulkCreateEvent(payload) {
    var _a = serializer(_bulkCreateEventRequest, { _event: _event, _maskedEvent: _maskedEvent, _recurrenceRule: _recurrenceRule, _zonedDate: _zonedDate }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateEventResponse, {
        _bulkEventResult: _bulkEventResult,
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __bulkCreateEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.BulkCreateEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/bulk/events/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateEvent.fromReq = fromReq;
    __bulkCreateEvent.__isAmbassador = true;
    return __bulkCreateEvent;
}
/** Updates an event. */
export function updateEvent(payload) {
    var _a = serializer(_updateEventRequest, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateEventResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __updateEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'PATCH',
            methodFqn: 'wix.calendar.events.v3.EventsService.UpdateEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events/{event.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateEvent.fromReq = fromReq;
    __updateEvent.__isAmbassador = true;
    return __updateEvent;
}
/** Updates multiple events in bulk. */
export function bulkUpdateEvent(payload) {
    var _a = serializer(_bulkUpdateEventRequest, { _bulkUpdateEventRequestMaskedEvent: _bulkUpdateEventRequestMaskedEvent, _event: _event, _recurrenceRule: _recurrenceRule, _zonedDate: _zonedDate }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateEventResponse, {
        _bulkEventResult: _bulkEventResult,
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __bulkUpdateEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.BulkUpdateEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/bulk/events/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateEvent.fromReq = fromReq;
    __bulkUpdateEvent.__isAmbassador = true;
    return __bulkUpdateEvent;
}
/** Restore default event values from the schedule or the recurring event. */
export function restoreEventDefaults(payload) {
    var _a = serializer(_restoreEventDefaultsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_restoreEventDefaultsResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __restoreEventDefaults(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.RestoreEventDefaults',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events/{eventId}/restore-defaults',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __restoreEventDefaults.fromReq = fromReq;
    __restoreEventDefaults.__isAmbassador = true;
    return __restoreEventDefaults;
}
/**
 * Splits a recurring event at a provided future date into two recurring events.
 *
 * Recurring event instances starting at or after the split date will belong to the new recurring event.
 *
 * Upon split, the following happens:
 * - The recurring event is set to end in the last instance before the split date.
 * - A new recurring event is created which set to start from the next instance starting at/after the split date.
 * - Recurring event exceptions which start at/after the split date are updated with the new recurring event ID.
 *
 * The split date must be a future date between two instances of the recurring event.
 */
export function splitRecurringEvent(payload) {
    var _a = serializer(_splitRecurringEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_splitRecurringEventResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __splitRecurringEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.SplitRecurringEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events/{recurringEventId}/split',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __splitRecurringEvent.fromReq = fromReq;
    __splitRecurringEvent.__isAmbassador = true;
    return __splitRecurringEvent;
}
/** Cancels an event. */
export function cancelEvent(payload) {
    var _a = serializer(_cancelEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelEventResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __cancelEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.CancelEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events/{eventId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelEvent.fromReq = fromReq;
    __cancelEvent.__isAmbassador = true;
    return __cancelEvent;
}
/** Cancels multiple events in bulk. */
export function bulkCancelEvent(payload) {
    var _a = serializer(_bulkCancelEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCancelEventResponse, {
        _bulkEventResult: _bulkEventResult,
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __bulkCancelEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.BulkCancelEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/bulk/events/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCancelEvent.fromReq = fromReq;
    __bulkCancelEvent.__isAmbassador = true;
    return __bulkCancelEvent;
}
/**
 * Retrieves a list of events by a participant's contact ID.
 *
 * Limits:
 * - Max time range is 1 year.
 */
export function listEventsByContactId(payload) {
    var _a = serializer(_listEventsByContactIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listEventsByContactIdResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __listEventsByContactId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'GET',
            methodFqn: 'wix.calendar.participantevents.v3.ParticipantEventsService.ListEventsByContactId',
            url: resolveWixCalendarParticipanteventsV3ParticipantEventsServiceUrl({
                protoPath: '/v3/events/contactId/{contactId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listEventsByContactId.fromReq = fromReq;
    __listEventsByContactId.__isAmbassador = true;
    return __listEventsByContactId;
}
/**
 * Retrieves a list of events by a participant's member ID.
 *
 * Limits:
 * - Max time range is 1 year.
 */
export function listEventsByMemberId(payload) {
    var _a = serializer(_listEventsByMemberIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listEventsByMemberIdResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __listEventsByMemberId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'GET',
            methodFqn: 'wix.calendar.participantevents.v3.ParticipantEventsService.ListEventsByMemberId',
            url: resolveWixCalendarParticipanteventsV3ParticipantEventsServiceUrl({
                protoPath: '/v3/events/memberId/{memberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listEventsByMemberId.fromReq = fromReq;
    __listEventsByMemberId.__isAmbassador = true;
    return __listEventsByMemberId;
}
//# sourceMappingURL=http.impl.js.map